var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M9 6a1 1 0 0 1 0 2H3v8h6a1 1 0 1 1 0 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2zm12 0a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-6a1 1 0 1 1 0-2h6V8h-6a1 1 0 1 1 0-2zm-5 5a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }